import { store } from '@/store'
import * as actions from '@/store/ActionTypes'

export default function loadTournament (to, from, next) {
  store.dispatch(actions.LOAD_TOURNAMENT, to.params)
    .then(() => {
      next()
    })
}
